
import { application } from "./application";

// Auto-imported local controllers
import Controller0 from "./ace_editor_controller.js";
import Controller1 from "./active_link_controller.js";
import Controller2 from "./add_on_kind_controller.js";
import Controller3 from "./autofocus_controller.js";
import Controller4 from "./bundle_toggle_controller.js";
import Controller5 from "./calendar_dropdown_controller.js";
import Controller6 from "./checkbox_observer_controller.js";
import Controller7 from "./checkbox_select_all_controller.js";
import Controller8 from "./choices_controller.js";
import Controller9 from "./choose_or_create_controller.js";
import Controller10 from "./click_controller.js";
import Controller11 from "./clipboard_controller.js";
import Controller12 from "./cmd_enter_controller.js";
import Controller13 from "./color_field_controller.js";
import Controller14 from "./color_scheme_controller.js";
import Controller15 from "./coloris_setup_controller.js";
import Controller16 from "./composer_tabs_controller.js";
import Controller17 from "./create_event_controller.js";
import Controller18 from "./cropper_controller.js";
import Controller19 from "./current_item_controller.js";
import Controller20 from "./custom_field_form_controller.js";
import Controller21 from "./custom_metadata_validation_controller.js";
import Controller22 from "./default_to_placeholder_controller.js";
import Controller23 from "./dependent_checkboxes_controller.js";
import Controller24 from "./disable_click_controller.js";
import Controller25 from "./disable_other_element_controller.js";
import Controller26 from "./docs_api_token_controller.js";
import Controller27 from "./docs_code_tabs_controller.js";
import Controller28 from "./docs_nav_controller.js";
import Controller29 from "./docs_search_controller.js";
import Controller30 from "./docs_tooltip_controller.js";
import Controller31 from "./draft_controller.js";
import Controller32 from "./dynamic_turbo_frame_controller.js";
import Controller33 from "./edit_venue_controller.js";
import Controller34 from "./event_preview_controller.js";
import Controller35 from "./example_promotion_codes_controller.js";
import Controller36 from "./flash_controller.js";
import Controller37 from "./html_template_form_controller.js";
import Controller38 from "./inactive_overlay_controller.js";
import Controller39 from "./inspector_tabs_controller.js";
import Controller40 from "./integration_field_mapping_controller.js";
import Controller41 from "./lazy_iframe_controller.js";
import Controller42 from "./modal_controller.js";
import Controller43 from "./nested_form_controller.js";
import Controller44 from "./new_data_indicator_controller.js";
import Controller45 from "./offer_interval_controller.js";
import Controller46 from "./open_modal_controller.js";
import Controller47 from "./palette_color_controller.js";
import Controller48 from "./password_strength_controller.js";
import Controller49 from "./placeholder_override_controller.js";
import Controller50 from "./places_autocomplete_controller.js";
import Controller51 from "./poll_refresh_controller.js";
import Controller52 from "./popover_hint_controller.js";
import Controller53 from "./preserve_ids_in_url_controller.js";
import Controller54 from "./price_and_tax_controller.js";
import Controller55 from "./remote_modal_controller.js";
import Controller56 from "./reset_to_default_controller.js";
import Controller57 from "./reveal_controller.js";
import Controller58 from "./scroll_to_selected_controller.js";
import Controller59 from "./search_form_controller.js";
import Controller60 from "./slug_controller.js";
import Controller61 from "./sms_counter_controller.js";
import Controller62 from "./sortable_controller.js";
import Controller63 from "./status_controller.js";
import Controller64 from "./sync_inputs_controller.js";
import Controller65 from "./tablist_controller.js";
import Controller66 from "./tax_rate_attachment_controller.js";
import Controller67 from "./templates_nav_link_controller.js";
import Controller68 from "./textarea_autogrow_controller.js";
import Controller69 from "./textarea_suggest_controller.js";
import Controller70 from "./time_controller.js";
import Controller71 from "./time_dropdown_controller.js";
import Controller72 from "./tiptap_controller.js";
import Controller73 from "./tooltip_controller.js";
import Controller74 from "./uppy_controller.js";
import Controller75 from "./venue_field_controller.js";
import Controller76 from "./web_authn_controller.js";
import Controller77 from "./widget_form_controller.js";

application.register("ace-editor", Controller0);
application.register("active-link", Controller1);
application.register("add-on-kind", Controller2);
application.register("autofocus", Controller3);
application.register("bundle-toggle", Controller4);
application.register("calendar-dropdown", Controller5);
application.register("checkbox-observer", Controller6);
application.register("checkbox-select-all", Controller7);
application.register("choices", Controller8);
application.register("choose-or-create", Controller9);
application.register("click", Controller10);
application.register("clipboard", Controller11);
application.register("cmd-enter", Controller12);
application.register("color-field", Controller13);
application.register("color-scheme", Controller14);
application.register("coloris-setup", Controller15);
application.register("composer-tabs", Controller16);
application.register("create-event", Controller17);
application.register("cropper", Controller18);
application.register("current-item", Controller19);
application.register("custom-field-form", Controller20);
application.register("custom-metadata-validation", Controller21);
application.register("default-to-placeholder", Controller22);
application.register("dependent-checkboxes", Controller23);
application.register("disable-click", Controller24);
application.register("disable-other-element", Controller25);
application.register("docs-api-token", Controller26);
application.register("docs-code-tabs", Controller27);
application.register("docs-nav", Controller28);
application.register("docs-search", Controller29);
application.register("docs-tooltip", Controller30);
application.register("draft", Controller31);
application.register("dynamic-turbo-frame", Controller32);
application.register("edit-venue", Controller33);
application.register("event-preview", Controller34);
application.register("example-promotion-codes", Controller35);
application.register("flash", Controller36);
application.register("html-template-form", Controller37);
application.register("inactive-overlay", Controller38);
application.register("inspector-tabs", Controller39);
application.register("integration-field-mapping", Controller40);
application.register("lazy-iframe", Controller41);
application.register("modal", Controller42);
application.register("nested-form", Controller43);
application.register("new-data-indicator", Controller44);
application.register("offer-interval", Controller45);
application.register("open-modal", Controller46);
application.register("palette-color", Controller47);
application.register("password-strength", Controller48);
application.register("placeholder-override", Controller49);
application.register("places-autocomplete", Controller50);
application.register("poll-refresh", Controller51);
application.register("popover-hint", Controller52);
application.register("preserve-ids-in-url", Controller53);
application.register("price-and-tax", Controller54);
application.register("remote-modal", Controller55);
application.register("reset-to-default", Controller56);
application.register("reveal", Controller57);
application.register("scroll-to-selected", Controller58);
application.register("search-form", Controller59);
application.register("slug", Controller60);
application.register("sms-counter", Controller61);
application.register("sortable", Controller62);
application.register("status", Controller63);
application.register("sync-inputs", Controller64);
application.register("tablist", Controller65);
application.register("tax-rate-attachment", Controller66);
application.register("templates-nav-link", Controller67);
application.register("textarea-autogrow", Controller68);
application.register("textarea-suggest", Controller69);
application.register("time", Controller70);
application.register("time-dropdown", Controller71);
application.register("tiptap", Controller72);
application.register("tooltip", Controller73);
application.register("uppy", Controller74);
application.register("venue-field", Controller75);
application.register("web-authn", Controller76);
application.register("widget-form", Controller77);
